/**
 * cart-drawer-connect.js
 * Load this ONCE, globally (e.g. via theme.liquid, after header-everlast.js).
 * It intercepts ANY add-to-cart action on the site and:
 *   1. Adds the item via /cart/add.js (AJAX, no page reload)
 *   2. Refreshes the cart-drawer section (line items, subtotal, count)
 *   3. Opens the cart drawer
 *
 * Works with two patterns — use whichever matches your button markup:
 *
 * PATTERN A — standard Shopify product form (PDP "Add to cart" button)
 *   {% form 'product', product %}
 *     <select name="id"> ...variants... </select>
 *     <button type="submit">Add to cart</button>
 *   {% endform %}
 *   -> No changes needed to your button. This script auto-detects any
 *      <form> whose action contains "/cart/add" and intercepts its submit.
 *
 * PATTERN B — quick-add buttons NOT inside a form (collection grids, upsells,
 * "buy again" buttons, custom bundle builders, etc.)
 *   <button type="button" data-quick-add data-variant-id="{{ variant.id }}" data-quantity="1">
 *     Add to cart
 *   </button>
 *   -> Any element with [data-quick-add] + [data-variant-id] is intercepted
 *      on click. data-quantity is optional (defaults to 1).
 */
(function () {
  if (window.__cartDrawerConnectInit) return;
  window.__cartDrawerConnectInit = true;

  function openDrawerAndRefresh() {
    document.dispatchEvent(new Event('cart:refresh'));
    document.dispatchEvent(new Event('cart:open'));
  }

  function addToCart(items, triggerEl) {
    if (triggerEl) {
      triggerEl.disabled = true;
      triggerEl.classList.add('is-loading');
    }
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        openDrawerAndRefresh();
      })
      .catch(function (err) {
        console.error('Add to cart failed:', err);
        var message = (err && err.description) || 'Could not add this item to cart.';
        alert(message);
      })
      .finally(function () {
        if (triggerEl) {
          triggerEl.disabled = false;
          triggerEl.classList.remove('is-loading');
        }
      });
  }

  // ---------- PATTERN A: standard product forms posting to /cart/add ----------
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!/\/cart\/add(\.js)?(\?|$)/.test(form.action)) return;

    e.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    var formData = new FormData(form);

    var variantId = formData.get('id');
    var quantity = parseInt(formData.get('quantity'), 10) || 1;

    // Collect any line item properties (properties[xxx]) and selling plan if present
    var item = { id: variantId, quantity: quantity };
    var sellingPlan = formData.get('selling_plan');
    if (sellingPlan) item.selling_plan = sellingPlan;

    var properties = {};
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    });
    if (Object.keys(properties).length) item.properties = properties;

    addToCart([item], submitBtn);
  });

  // ---------- PATTERN B: quick-add buttons with data-quick-add ----------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();

    var variantId = btn.dataset.variantId;
    if (!variantId) {
      console.warn('data-quick-add button is missing data-variant-id.');
      return;
    }
    var quantity = parseInt(btn.dataset.quantity, 10) || 1;

    var item = { id: variantId, quantity: quantity };
    if (btn.dataset.sellingPlan) item.selling_plan = btn.dataset.sellingPlan;

    addToCart([item], btn);
  });
})();
